import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { Observable, of } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class MatrizDocumentoService extends ApiService {
  constructor(http: HttpClient, authService: NbAuthService) {
    super(http, authService);
  }

  Generar(matrizDocumento: MatrizDocumento): Observable<DocumentoVariables | null> {
    if (!matrizDocumento)
      return of(null);
    return this.get<DocumentoVariables>('/api/MatrizDocumento/Generar', matrizDocumento);
  }

  EnviarInforme(correoDocumento: CorreoDocumento): Observable<any | null> {
    if (!correoDocumento)
      return of(null);
    return this.post<any>('/api/MatrizDocumento/EnviarInforme', correoDocumento);
  }

  Add(Documento: AddDocumento): Observable<IDDocumentoSoportes | null> {
    const formData = new FormData();
    if (Documento) {
      if (Documento.Soportes)
        for (const file of Documento.Soportes)
          formData.append('files', file, file.name);

      if (Documento.IDCaso)
        formData.append('IDCaso', Documento.IDCaso.toString());

      if (Documento.IDProceso)
        formData.append('IDProceso', Documento.IDProceso.toString());

      if (Documento.IDProcesoNumero)
        formData.append('IDProcesoNumero', Documento.IDProcesoNumero.toString());

      if (Documento.ValorPregunta)
        formData.append('ValorPregunta', Documento.ValorPregunta.toString());

      if (Documento.BodyDocumento)
        formData.append('BodyDocumento', Documento.BodyDocumento.toString());

      if (Documento.BodyDocumentoOriginal)
        formData.append('BodyDocumentoOriginal', Documento.BodyDocumentoOriginal.toString());
    }
    return this.post<IDDocumentoSoportes>('/api/MatrizDocumento/Add', formData);
  }

  GuardarVariables(variables: VariablesDocumento): Observable<any | null> {
    return this.post<any>('/api/MatrizDocumento/AddDocumentoGeneradosVariables', variables);
  }

  GetGrupoVariable(): Observable<GrupoVariables[] | null> {
    return this.get<GrupoVariables[]>('/api/MatrizDocumento/GetListaGrupoVariables');
  }

  AddMatrizVariable(variable: Variable): Observable<number | null> {
    return this.post<number>('/api/MatrizDocumento/AddMatrizVariable', variable);
  }

  AddMatrizDocumento(matrizDocumento: GuardarMatrizDocumento): Observable<number | null> {
    return this.post<number>('/api/MatrizDocumento/AddMatrizDocumento', matrizDocumento);
  }

  AddMatrizDocumentoVariables(matrizDocumento: GuardarMatrizDocumentoVariables): Observable<number[] | null> {
    return this.post<number[]>('/api/MatrizDocumento/AddMatrizDocumentoVariables', matrizDocumento);
  }

}

export interface MatrizDocumento {
  ValorPregunta?: string,
  TipoVariable?: string,
  FechaRespuesta?: string,
  Caso?: number,
  Proceso?: number,
  NumeroProceso?: number
}

export interface DocumentoVariables {
  html: string,
  valor: MatrizDocumentoVariables[],
  correoUsuario: string
}

export interface CorreoDocumento {
  para?: string,
  conCopia?: string,
  correoAlternativoDespacho?: string,
  asunto?: string,
  mensaje?: string,
  mensajeEntidad?: string,
  mensajeComplementoUno?: string,
  mensajeComplementoDos?: string,
  mensajeComplementoTres?: string,
  IDDocumentoSoporte?: number,
  IDSoporte?: number[],
  iIDProceso?: string,
  iIDProcesoNumero?: string
}

export interface AddDocumento {
  IDCaso?: number,
  IDProceso?: number,
  IDProcesoNumero?: number,
  ValorPregunta?: string,
  Documento?: File[],
  Soportes?: File[],
  BodyDocumento?: string,
  BodyDocumentoOriginal?: string
}

export interface VariablesDocumento {
  IDDocumentoGenerado?: number,
  VariablesDocumento?: MatrizDocumentoVariables[]
}

export interface IDDocumentoSoportes {
  item1: number,
  item2: number[]
}

export interface MatrizDocumentoVariables {
  id: number,
  valor: string,
  iIDSubTablaTipoVariable: number,
  tIDValorTipoVariable: string,
  iIDSubTablaTipoCampo: number,
  tIDValorTipoCampo: string
}

export interface GrupoVariables {
  id: number,
  descripcion: string,
  children: SubVariable[]
}
export interface SubVariable {
  nombreVariable: string;
  id: number;
  descripcion: string;
  tipoCampo: string;
}

export interface ValoresAgregados {
  tIDValor: string;
  iOrden: number;
  tDescripcionValor: string;
  iTipoParametro: number;
  Valor: any;
}

export interface Variable {

  iIDMatrizGrupoVariable?: number;
  tNombreVariable: string;
  iIDSubTablaTipoCampo: number;
  tIDValorTipoCampo?: string;
  tDescripcionVariable: string;
  iIDSubTablaVariable?: number;

}

export interface GuardarMatrizDocumento {

  iIDEntidad: number | null;
  iIDSubTablaMatrizDocumentoTipo: number;
  tIDValorMatrizDocumentoTipo: string;
  tNombreDocumento?: string;
  tBodyDocumento?: string;

}

export interface GuardarMatrizDocumentoVariables {
  idVariables?: number[];
  iIDMatrizDocumento?: number | null;
}
